/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DiffRecord } from "./DiffRecord";
export const DiffRecords = core.serialization.list(DiffRecord);
